export default {"src":"/_next/static/media/address_user.11537b7f.svg","height":20,"width":20};